import { Json } from '@/integrations/supabase/types/common';

// Contact placeholder data
export const PLACEHOLDER_CONTACTS = [
  {
    id: '1',
    first_name: 'Alex',
    last_name: 'Johnson',
    email: 'alex.johnson@example.com',
    phone: '(555) 123-4567',

    extra_fields: {
      industry: 'Technology',
      status: 'lead',
      notes: 'Met at tech conference'
    },
    crm_companies: {
      name: 'TechCorp',
      extra_fields: { industry: 'Technology' }
    }
  },
  {
    id: '2',
    first_name: 'Sam',
    last_name: 'Taylor',
    email: 'sam.taylor@example.com',
    phone: '(555) 987-6543',
    extra_fields: {
      industry: 'Healthcare',
      status: 'qualified',
      notes: 'Interested in enterprise solution'
    },
    crm_companies: {
      name: 'MediHealth',
      extra_fields: { industry: 'Healthcare' }
    }
  },
  {
    id: '3',
    first_name: 'Jordan',
    last_name: 'Rivera',
    email: 'jordan.rivera@example.com',
    phone: '(555) 456-7890',

    extra_fields: {
      industry: 'Finance',
      status: 'proposal',
      notes: 'Scheduled follow-up meeting'
    },
    crm_companies: {
      name: 'InvestGroup',
      extra_fields: { industry: 'Finance' }
    }
  },
  {
    id: '4',
    first_name: 'Morgan',
    last_name: 'Chen',
    email: 'morgan.chen@example.com',
    phone: '(555) 789-0123',

    extra_fields: {
      industry: 'Retail',
      status: 'lead',
      notes: 'Referred by existing client'
    }
  },
  {
    id: '5',
    first_name: 'Jamie',
    last_name: 'Wilson',
    email: 'jamie.wilson@example.com',
    phone: '(555) 234-5678',
    extra_fields: {
      industry: 'Healthcare',
      status: 'negotiation',
      notes: 'Decision pending board approval'
    },
    crm_companies: {
      name: 'MediHealth',
      extra_fields: { industry: 'Healthcare' }
    }
  }
];

// Company placeholder data
export const PLACEHOLDER_COMPANIES = [
  {
    id: '1',
    name: 'TechCorp',
    industry: 'Technology',
    location: 'San Francisco, CA',
    employee_count: 250,
    revenue: 5000000,
    website: 'https://techcorp.example.com',
    address: '123 Tech Avenue, San Francisco, CA 94105',
    sales_status: 'qualified',
    service_status: 'active',
    extra_fields: {
      industry: 'Technology',
      sector: 'Software Development',
      revenue_range: '$1M-$10M'
    }
  },
  {
    id: '2',
    name: 'MediHealth',
    industry: 'Healthcare',
    location: 'Boston, MA',
    employee_count: 500,
    revenue: 12000000,
    website: 'https://medihealth.example.com',
    address: '456 Health Street, Boston, MA 02108',
    sales_status: 'proposal',
    service_status: 'onboarding',
    extra_fields: {
      industry: 'Healthcare',
      sector: 'Medical Services',
      revenue_range: '$10M-$50M'
    }
  },
  {
    id: '3',
    name: 'InvestGroup',
    industry: 'Finance',
    location: 'New York, NY',
    employee_count: 180,
    revenue: 8500000,
    website: 'https://investgroup.example.com',
    address: '789 Finance Ave, New York, NY 10004',
    sales_status: 'negotiation',
    service_status: 'lead',
    extra_fields: {
      industry: 'Finance',
      sector: 'Investment Banking',
      revenue_range: '$5M-$20M'
    }
  },
  {
    id: '4',
    name: 'RetailPlus',
    industry: 'Retail',
    location: 'Chicago, IL',
    employee_count: 320,
    revenue: 6200000,
    website: 'https://retailplus.example.com',
    address: '101 Retail Drive, Chicago, IL 60601',
    sales_status: 'lead',
    service_status: 'lead',
    extra_fields: {
      industry: 'Retail',
      sector: 'Consumer Goods',
      revenue_range: '$5M-$20M'
    }
  },
  {
    id: '5',
    name: 'EcoSolutions',
    industry: 'Energy',
    location: 'Denver, CO',
    employee_count: 85,
    revenue: 3400000,
    website: 'https://ecosolutions.example.com',
    address: '567 Green Road, Denver, CO 80202',
    sales_status: 'closed',
    service_status: 'active',
    extra_fields: {
      industry: 'Energy',
      sector: 'Renewable Energy',
      revenue_range: '$1M-$10M'
    }
  }
];

// Pipeline placeholder data
export const PLACEHOLDER_PIPELINE = [
  {
    id: '1',
    name: 'Alex Johnson',
    company: 'TechCorp',
    email: 'alex.johnson@example.com',
    phone: '(555) 123-4567',
    value: 50000,
    stage: 'qualified' as const,
    industry: 'Technology',
    createdAt: '2024-04-01T10:30:00Z',
    updatedAt: '2024-04-15T14:45:00Z'
  },
  {
    id: '2',
    name: 'Sam Taylor',
    company: 'MediHealth',
    email: 'sam.taylor@example.com',
    phone: '(555) 987-6543',
    value: 75000,
    stage: 'proposal' as const,
    industry: 'Healthcare',
    createdAt: '2024-03-15T09:20:00Z',
    updatedAt: '2024-04-10T11:35:00Z'
  },
  {
    id: '3',
    name: 'Jordan Rivera',
    company: 'InvestGroup',
    email: 'jordan.rivera@example.com',
    phone: '(555) 456-7890',
    value: 120000,
    stage: 'negotiation' as const,
    industry: 'Finance',
    createdAt: '2024-02-25T14:10:00Z',
    updatedAt: '2024-04-12T16:25:00Z'
  },
  {
    id: '4',
    name: 'Morgan Chen',
    company: 'RetailPlus',
    email: 'morgan.chen@example.com',
    phone: '(555) 789-0123',
    value: 30000,
    stage: 'lead' as const,
    industry: 'Retail',
    createdAt: '2024-04-05T11:50:00Z',
    updatedAt: '2024-04-05T11:50:00Z'
  },
  {
    id: '5',
    name: 'Jamie Wilson',
    company: 'MediHealth',
    email: 'jamie.wilson@example.com',
    phone: '(555) 234-5678',
    value: 85000,
    stage: 'closed' as const,
    industry: 'Healthcare',
    createdAt: '2024-01-20T10:15:00Z',
    updatedAt: '2024-04-01T15:40:00Z'
  }
];

// Projects placeholder data
export const PLACEHOLDER_PROJECTS = [
  {
    id: '1',
    name: 'Website Redesign',
    description: 'Overhaul the company website with a modern design and improved UX',
    progress: 75,
    dueDate: '2025-05-15',

    status: 'in_progress',
    client: 'TechCorp'
  },
  {
    id: '2',
    name: 'Mobile App Development',
    description: 'Create a cross-platform mobile application for customer engagement',
    progress: 40,
    dueDate: '2025-06-30',

    status: 'planning',
    client: 'MediHealth'
  },
  {
    id: '3',
    name: 'Analytics Integration',
    description: 'Implement advanced analytics tracking across digital properties',
    progress: 20,
    dueDate: '2025-07-10',

    status: 'planning',
    client: 'InvestGroup'
  },
  {
    id: '4',
    name: 'E-commerce Platform',
    description: 'Build a scalable online shopping platform with inventory management',
    progress: 60,
    dueDate: '2025-05-30',

    status: 'in_progress',
    client: 'RetailPlus'
  },
  {
    id: '5',
    name: 'Brand Identity Refresh',
    description: 'Update visual identity including logo, colors, and brand guidelines',
    progress: 90,
    dueDate: '2025-04-25',

    status: 'review',
    client: 'EcoSolutions'
  }
];

// Fulfillment placeholder data
export const PLACEHOLDER_FULFILLMENT = [
  {
    id: '1',
    title: 'Website Redesign',
    description: 'Overhaul the company website with a modern design and improved UX',
    company: 'TechCorp',
    contact: 'Alex Johnson',
    status: 'development',
    dueDate: '2025-05-15',
    team: ['Jane Doe', 'John Smith', 'Alice Brown'],
    progress: 65
  },
  {
    id: '2',
    title: 'Mobile App Development',
    description: 'Create a cross-platform mobile application for customer engagement',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'design',
    dueDate: '2025-06-30',
    team: ['Bob White', 'Sarah Green', 'Mike Blue', 'Lisa Gray'],
    progress: 40
  },
  {
    id: '3',
    title: 'Analytics Dashboard',
    description: 'Build a real-time analytics dashboard for executive reporting',
    company: 'InvestGroup',
    contact: 'Jordan Rivera',
    status: 'planning',
    dueDate: '2025-07-10',
    team: ['Chris Purple', 'Emma Yellow'],
    progress: 15
  },
  {
    id: '4',
    title: 'E-commerce Platform',
    description: 'Build a scalable online shopping platform with inventory management',
    company: 'RetailPlus',
    contact: 'Morgan Chen',
    status: 'testing',
    dueDate: '2025-05-30',
    team: ['David Orange', 'Olivia Red', 'Tom Black'],
    progress: 85
  },
  {
    id: '5',
    title: 'Brand Identity Refresh',
    description: 'Update visual identity including logo, colors, and brand guidelines',
    company: 'EcoSolutions',
    contact: 'Jamie Wilson',
    status: 'approval',
    dueDate: '2025-04-25',
    team: ['Rachel Pink', 'Nathan Brown'],
    progress: 90
  },
  {
    id: '6',
    title: 'CRM Integration',
    description: 'Integrate customer relationship management system with existing platforms',
    company: 'TechCorp',
    contact: 'Alex Johnson',
    status: 'discovery',
    dueDate: '2025-07-15',
    team: ['Mark Gold', 'Sophia Silver'],
    progress: 10
  },
  {
    id: '7',
    title: 'Content Management System',
    description: 'Implement a custom CMS for easy content updates and management',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'scoping',
    dueDate: '2025-06-10',
    team: ['Ryan Teal', 'Natalie Cyan'],
    progress: 25
  },
  {
    id: '8',
    title: 'Payment Gateway Integration',
    description: 'Add secure payment processing capabilities to existing platform',
    company: 'RetailPlus',
    contact: 'Morgan Chen',
    status: 'proposal',
    dueDate: '2025-05-20',
    team: ['Victor Violet', 'Penelope Plum'],
    progress: 30
  },
  {
    id: '9',
    title: 'Security Audit & Implementation',
    description: 'Comprehensive security review and implementation of best practices',
    company: 'InvestGroup',
    contact: 'Jordan Rivera',
    status: 'review',
    dueDate: '2025-06-05',
    team: ['Howard Hazel', 'Irene Ivory'],
    progress: 80
  },
  {
    id: '10',
    title: 'Cloud Migration',
    description: 'Migrate on-premise infrastructure to cloud-based solutions',
    company: 'EcoSolutions',
    contact: 'Jamie Wilson',
    status: 'deployment',
    dueDate: '2025-04-30',
    team: ['Quentin Quartz', 'Ursula Umber'],
    progress: 95
  },
  {
    id: '11',
    title: 'Staff Training Program',
    description: 'Develop and deliver comprehensive training for new systems',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'training',
    dueDate: '2025-07-25',
    team: ['Xavier Xanthic', 'Yvonne Yellow'],
    progress: 70
  },
  {
    id: '12',
    title: 'Ongoing Maintenance',
    description: 'Regular updates, security patches, and performance optimization',
    company: 'TechCorp',
    contact: 'Alex Johnson',
    status: 'support',
    dueDate: '2025-12-31',
    team: ['Zach Zinc', 'Wendy White'],
    progress: 50
  },
  {
    id: '13',
    title: 'Social Media Strategy',
    description: 'Develop comprehensive social media presence and content calendar',
    company: 'RetailPlus',
    contact: 'Morgan Chen',
    status: 'discovery',
    dueDate: '2025-06-15',
    team: ['Adam Azure', 'Betty Beige'],
    progress: 5
  },
  {
    id: '14',
    title: 'Data Analytics Platform',
    description: 'Build custom analytics solution for business intelligence',
    company: 'InvestGroup',
    contact: 'Jordan Rivera',
    status: 'development',
    dueDate: '2025-08-10',
    team: ['Charlie Crimson', 'Donna Diamond'],
    progress: 60
  },
  {
    id: '15',
    title: 'Mobile App Phase 2',
    description: 'Add advanced features and functionality to existing mobile app',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'planning',
    dueDate: '2025-09-15',
    team: ['Edward Emerald', 'Fiona Fuchsia'],
    progress: 20
  }
];

// Column configuration placeholders
export const PLACEHOLDER_COLUMN_CONFIG = {
  contacts: [
    { key: 'first_name', header: 'First Name', type: 'text', width: 'w-[150px]', required: true, visible: true },
    { key: 'last_name', header: 'Last Name', type: 'text', width: 'w-[150px]', required: true, visible: true },
    { key: 'email', header: 'Email', type: 'email', width: 'w-[200px]', required: true, visible: true },
    { key: 'phone', header: 'Phone', type: 'phone', width: 'w-[150px]', required: false, visible: true },
    { key: 'company', header: 'Company', type: 'text', width: 'w-[180px]', required: false, visible: true },
    { key: 'industry', header: 'Industry', type: 'text', width: 'w-[150px]', required: false, visible: true },
    { key: 'status', header: 'Status', type: 'tag', width: 'w-[120px]', required: false, visible: true }
  ],
  
  companies: [
    { key: 'name', header: 'Company', type: 'text', width: 'w-[200px]', required: true, visible: true },
    { key: 'industry', header: 'Industry', type: 'text', width: 'w-[150px]', required: false, visible: true },
    { key: 'location', header: 'Location', type: 'text', width: 'w-[180px]', required: false, visible: true },
    { key: 'revenue_range', header: 'Revenue', type: 'text', width: 'w-[160px]', required: false, visible: true },
    { key: 'employee_count', header: 'Employees', type: 'text', width: 'w-[140px]', required: false, visible: true },
    { key: 'sales_status', header: 'Status', type: 'tag', width: 'w-[120px]', required: false, visible: true }
  ]
};
